import React, { useEffect, useState } from 'react';
import SourcesTable from '../tables/SourcesTable';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { tryToFetchAdminTemplateFiles, tryToFetchReconciles } from '../../../../store/brokers/partners/admin/adminSlice';
import ReconciliationTable from '../tables/ReconciliationsTable';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';

const sourcesColumns = [
    { name: 'File Name', key: 'fileName' },
    { name: 'Type', key: 'type' },
    { name: 'Upload Date', key: 'createdAt' },
    { name: 'Size', key: 'size' },
    { name: 'Records', key: 'records' },
    { name: 'Status', key: 'status' },
]

const Files = () => {
    const dispatch = useAppDispatch();
    const [reconcRows, setReconcRows] = useState<any>()
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const [templateFiles, setTempalteFiles] = useState<any>();
    const state = useAppSelector(state => state.admin)
    const paginationData = useAppSelector(state => state?.admin?.adminTemplateFiles?.data?.page)

    useEffect(() => {
        if (state.reconciliation) {
            setReconcRows(state.reconciliation)
        }
    }, [state?.reconciliation])

    const onGettingData = async () => {
        try {
            await dispatch(tryToFetchReconciles()).unwrap()
        } catch (err) {
            console.error(err)
        }
    }

    const onGettingTempalteData = async () => {
        try {
            await dispatch(tryToFetchAdminTemplateFiles(paginationState)).unwrap()
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(()=>{
        if(state?.adminTemplateFiles){
            setTempalteFiles(state?.adminTemplateFiles?.data?.elements)
        }
    },[state?.adminTemplateFiles])

    useEffect(() => {
        onGettingTempalteData()
    }, [paginationState])

    useEffect(() => {
        onGettingData()
    }, [])

    return (
        <div className='mt-5'>
            <p className='font-bold dark:text-primary-dark text-xl mb-5'>Source Files</p>
            <SourcesTable
                columns={sourcesColumns}
                rows={templateFiles}
                paginationData={paginationData}
                paginationState={paginationState}
                setPaginationState={setPaginationState}
            />
            <p className='font-bold dark:text-primary-dark text-xl mt-10 mb-5'>Reconciliation Templates</p>
            <ReconciliationTable
                rows={reconcRows}
            />
        </div>
    )
}
export default Files;